// extracted by mini-css-extract-plugin
export default {"switch":"Toggle_switch__OWSrI","slider":"Toggle_slider__CaBI0"};